/**
 * Belo Product Options Section
 * 
 * This JavaScript file is adapted from belo-product-page.js but designed to work
 * within a section context. The original file remains unchanged.
 * 
 * @copyright Belo 2025
 * @license Proprietary - Unauthorized copying of this file is strictly prohibited
 */

(function(window, document) {
  'use strict';
  
  // Protect global scope
  const _b = {};
  
  class BeloProductOptions {
  constructor(container) {
    // Store the section container
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    
    // Product configuration - can be overridden by section settings
    this.productConfig = {
      basePrice: 39.00, // Base price per jar in AUD
      quantityDiscounts: {
        1: 0,          // No discount for 1 jar
        2: 1.95,       // $3.30 discount per jar for 2 jars
        3: 4.33,       // $4.95 discount per jar for 3 jars
        4: 8.19        // $8.25 discount per jar for 4 jars
      },
      subscriptionDiscounts: {
        4: 0.10,       // 10% discount for 4-week frequency
        6: 0.10        // 10% discount for 6-week frequency
      },
      flavors: [
        { id: 'classic-lime', name: 'Classic Lime', benefits: ['Light Citrus'], image: 'PDP_classic-01', bestseller: false },
        { id: 'cool-spirulina', name: 'Cool Blue Spirulina & Coconut', benefits: ['Coconutty'], image: 'PDP_blue-01', bestseller: false },
        { id: 'honey-lemon', name: 'Soothing Honey Lemon & Matcha', benefits: ['Matcha with Honey'], image: 'PDP_matcha-01', bestseller: true },
        { id: 'berries', name: 'Fresh Mixed Berries', benefits: ['Berry Jam'], image: 'PDP_berries-01', bestseller: false },
        { id: 'tropical', name: 'Tropical Mango & Pineapple', benefits: ['Mangolicious'], image: 'PDP_yellow-01', bestseller: false },
        { id: 'pomegranate', name: 'Dragon Fruit & Pomegranate', benefits: ['Apple with Pomegranate'], image: 'pdp-Pomegranate', bestseller: false }
      ]
    };

    // DOM Elements - scoped to this section
    this.elements = {
      // Purchase type selection
      oneTimeOption: container.querySelector('.option.one-time'),
      subscribeOption: container.querySelector('.option.subscribe'),
      subscriptionOptions: container.querySelector('.subscription-options'),
      oneTimeText: container.querySelector('.one-time-text'),
      subscribeText: container.querySelector('.subscribe-text'),
      subscriptionNote: container.querySelector('.subscription-note'),
      subscriptionDiscount: container.querySelector('.subscription-discount'),
      
      // Quantity selection
      quantityOptions: container.querySelectorAll('.quantity-option'),
      flavorInstruction: container.querySelector('.flavor-instruction'),
      
      // Frequency selection
      frequencyOptions: container.querySelectorAll('.frequency-option'),
      
      // Flavor selection
      quantityInputs: container.querySelectorAll('.quantity-input'),
      decreaseButtons: container.querySelectorAll('.quantity-decrease'),
      increaseButtons: container.querySelectorAll('.quantity-increase'),
      
      // Order summary
      selectedItems: container.querySelector('.selected-items'),
      subtotalValue: container.querySelector('.subtotal .value'),
      subscriptionDiscountValue: container.querySelector('.subscription-discount .value'),
      quantityDiscountValue: container.querySelector('.quantity-discount .value'),
      totalValue: container.querySelector('.total .value'),
      addToCartButton: container.querySelector('.add-to-cart-button')
    };

    // State
    this.state = {
      purchaseType: 'one-time', // Default to onc-time since that's the default UI state
      selectedQuantity: 1,
      selectedFrequency: 4, // Default to 4 weeks since that's selected in the UI
      discountPercentage: 10, // 10% for 4 weeks
      selectedFlavors: {},
      totalItems: 0
    };

    // Initialize
    this.init();
  }

  /**
   * Initialize the section
   */
  init() {
    // Set default state
    if (this.elements.quantityOptions.length > 0) {
      this.elements.quantityOptions[0].classList.add('selected');
    }
    
    // Set up event listeners
    this.setupPurchaseTypeListeners();
    this.setupQuantitySelectionListeners();
    this.setupFrequencySelectionListeners();
    this.setupFlavorSelectionListeners();
    this.setupAddToCartButton();
    
    // Set initial UI state to match our state
    if (this.state.purchaseType === 'one-time') {
      //this.elements.subscribeOption.classList.add('active');
      //this.elements.oneTimeOption.classList.remove('active');
      this.elements.oneTimeOption.classList.add('active')
      this.elements.subscribeOption.classList.remove('active')
      
    // Find the radio button within the option instead of by ID
    const oneTimeRadio = this.elements.oneTimeOption.querySelector('input[type="radio"]');
    if (oneTimeRadio) oneTimeRadio.checked = true;
      
     if (this.elements.subscriptionOptions) this.elements.subscriptionOptions.style.display = 'none';
     if (this.elements.oneTimeText) this.elements.oneTimeText.style.display = 'inline';
     if (this.elements.subscribeText) this.elements.subscribeText.style.display = 'none';
     if (this.elements.subscriptionNote) this.elements.subscriptionNote.style.display = 'none';
     if (this.elements.subscriptionDiscount) this.elements.subscriptionDiscount.style.display = 'none'; // Use flex to match CSS
    }
    
    // Initialize the order summary and flavor prices
    this.updateOrderSummary();
    this.updateFlavorPrices();
    
    // Initialization complete
  }

  /**
   * Set up purchase type selection listeners
   */
  setupPurchaseTypeListeners() {
    if (this.elements.oneTimeOption) {
      this.elements.oneTimeOption.addEventListener('click', () => {
        this.state.purchaseType = 'one-time';
        this.elements.oneTimeOption.classList.add('active');
        this.elements.subscribeOption.classList.remove('active');
        
        // Find the radio button within the option instead of by ID
        const oneTimeRadio = this.elements.oneTimeOption.querySelector('input[type="radio"]');
        if (oneTimeRadio) oneTimeRadio.checked = true;
        
        if (this.elements.subscriptionOptions) this.elements.subscriptionOptions.style.display = 'none';
        if (this.elements.oneTimeText) this.elements.oneTimeText.style.display = 'inline';
        if (this.elements.subscribeText) this.elements.subscribeText.style.display = 'none';
        if (this.elements.subscriptionNote) this.elements.subscriptionNote.style.display = 'none';
        if (this.elements.subscriptionDiscount) this.elements.subscriptionDiscount.style.display = 'none';
        
        this.updateOrderSummary();
        this.updateFlavorPrices();
      });
    }
    
    if (this.elements.subscribeOption) {
      this.elements.subscribeOption.addEventListener('click', () => {
        this.state.purchaseType = 'subscribe';
        this.elements.subscribeOption.classList.add('active');
        this.elements.oneTimeOption.classList.remove('active');
        
        // Find the radio button within the option instead of by ID
        const subscribeRadio = this.elements.subscribeOption.querySelector('input[type="radio"]');
        if (subscribeRadio) subscribeRadio.checked = true;
        
        if (this.elements.subscriptionOptions) this.elements.subscriptionOptions.style.display = 'block';
        if (this.elements.oneTimeText) this.elements.oneTimeText.style.display = 'none';
        if (this.elements.subscribeText) this.elements.subscribeText.style.display = 'inline';
        if (this.elements.subscriptionNote) this.elements.subscriptionNote.style.display = 'block';
        if (this.elements.subscriptionDiscount) this.elements.subscriptionDiscount.style.display = 'block';
        
        this.updateOrderSummary();
        this.updateFlavorPrices();
      });
    }
  }

  /**
   * Set up quantity selection listeners
   */
  setupQuantitySelectionListeners() {
    this.elements.quantityOptions.forEach(option => {
      option.addEventListener('click', () => {
        this.elements.quantityOptions.forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');
        this.state.selectedQuantity = parseInt(option.getAttribute('data-quantity'));
        
        if (this.elements.flavorInstruction) {
          this.elements.flavorInstruction.textContent = `Select ${this.state.selectedQuantity} flavors to get ${this.state.selectedQuantity} packs`;
        }
        
        this.updateOrderSummary();
        this.updateFlavorPrices();
      });
    });
  }

  /**
   * Set up frequency selection listeners
   */
  setupFrequencySelectionListeners() {
    this.elements.frequencyOptions.forEach(option => {
      option.addEventListener('click', () => {
        this.elements.frequencyOptions.forEach(opt => opt.classList.remove('active'));
        option.classList.add('active');
        this.state.selectedFrequency = parseInt(option.getAttribute('data-weeks'));
        
        // Set discount percentage based on frequency
        this.state.discountPercentage = this.productConfig.subscriptionDiscounts[this.state.selectedFrequency] * 100;
        
        // Update the radio button
        const frequencyRadio = option.querySelector('input[type="radio"]');
        if (frequencyRadio) frequencyRadio.checked = true;
        
        this.updateOrderSummary();
        this.updateFlavorPrices();
      });
    });
  }

  /**
   * Update the flavor prices based on purchase type and quantity
   */
  updateFlavorPrices() {
    // Get all flavor price elements
    const flavorItems = this.container.querySelectorAll('.flavor-item');
    
    // Base price
    const basePrice = this.productConfig.basePrice;
    
    // Calculate the price based on purchase type and quantity
    let discountedPrice = basePrice;
    
    // Apply quantity discount if applicable
    let effectiveQuantity = Math.min(4, Math.max(1, this.state.selectedQuantity));
    const quantityDiscount = this.productConfig.quantityDiscounts[effectiveQuantity];
    discountedPrice -= quantityDiscount;
    
    // Apply subscription discount if applicable
    if (this.state.purchaseType === 'subscribe') {
      const subscriptionDiscount = basePrice * this.productConfig.subscriptionDiscounts[this.state.selectedFrequency];
      discountedPrice -= subscriptionDiscount;
    }
    
    // Update all flavor price elements
    flavorItems.forEach(item => {
      const originalPriceElement = item.querySelector('.original-price');
      const salePriceElement = item.querySelector('.sale-price');
      
      if (originalPriceElement) {
        originalPriceElement.textContent = `A$${basePrice.toFixed(2)}`;
      }
      
      if (salePriceElement) {
        salePriceElement.textContent = `A$${discountedPrice.toFixed(2)}`;
      }
    });
  }

  /**
   * Set up flavor selection listeners
   */
  setupFlavorSelectionListeners() {
    // Reset all quantity inputs to 0 on initialization to ensure consistent state
    this.elements.quantityInputs.forEach(input => {
      input.value = 0;
    });
    
    // Add a MutationObserver to monitor changes to the first flavor's input value
    const firstFlavorInput = this.elements.quantityInputs[0];
    if (firstFlavorInput) {
      // Create a MutationObserver to watch for value changes
      const observer = new MutationObserver((mutations) => {
        // Monitor value changes silently
      });
      
      // Configure the observer to watch for attribute changes
      observer.observe(firstFlavorInput, { 
        attributes: true, 
        attributeFilter: ['value'] 
      });
    }
    
    // Function to update the flavor instruction text
    const updateFlavorInstruction = () => {
      if (!this.elements.flavorInstruction) return;
      
      let totalQuantity = 0;
      this.elements.quantityInputs.forEach(input => {
        totalQuantity += parseInt(input.value) || 0;
      });
      
      if (totalQuantity > 0) {
        this.elements.flavorInstruction.textContent = `Select flavors (current total: ${totalQuantity})`;
      } else {
        this.elements.flavorInstruction.textContent = `Select flavors to add to your order`;
      }
    };
    
    // Function to check if any flavors are selected
    const anyFlavorsSelected = () => {
      let totalSelected = 0;
      this.elements.quantityInputs.forEach(input => {
        totalSelected += parseInt(input.value) || 0;
      });
      return totalSelected > 0;
    };
    
    // Function to update the Add to Cart button state
    const updateButtonState = () => {
      if (this.elements.addToCartButton) {
        this.elements.addToCartButton.disabled = !anyFlavorsSelected();
      }
    };
    
    // Add event listeners to flavor quantity controls
    this.elements.decreaseButtons.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        // Add a custom flag to the event to indicate that our handler has processed it
        if (event.beloHandled) return;
        event.beloHandled = true;
        
        const input = this.elements.quantityInputs[index];
        const flavorId = input.getAttribute('data-flavor');
        
        // Force parse as integer and default to 0 if NaN
        let currentValue = parseInt(input.value);
        if (isNaN(currentValue)) currentValue = 0;
        
        if (currentValue > 0) {
          // Calculate the new value
          const newValue = currentValue - 1;
          
          // Set the new value
          input.value = newValue;
          
          // Create a custom event to notify other scripts that we've handled this click
          const customEvent = new CustomEvent('beloQuantityChanged', {
            detail: {
              sectionId: this.sectionId,
              index: index,
              value: newValue,
              input: input
            },
            bubbles: true
          });
          button.dispatchEvent(customEvent);
          
          // Update UI immediately
          updateFlavorInstruction();
          updateButtonState();
          this.updateSelectedFlavors(flavorId, newValue);
          
          // For all flavors, ensure the value is correct after a short delay
          // This handles any external scripts that might change the value
          setTimeout(() => {
            if (parseInt(input.value) !== newValue) {
              input.value = newValue;
              
              // Update UI again after fixing the value
              updateFlavorInstruction();
              updateButtonState();
              this.updateSelectedFlavors(flavorId, newValue);
            }
          }, 50);
        }
      }, true); // Use capture phase to ensure our handler runs first
    });
    
    // Add click event listeners to increase buttons
    this.elements.increaseButtons.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        // Add a custom flag to the event to indicate that our handler has processed it
        if (event.beloHandled) return;
        event.beloHandled = true;
        
        const input = this.elements.quantityInputs[index];
        const flavorId = input.getAttribute('data-flavor');
        
        // Force parse as integer and default to 0 if NaN
        let currentValue = parseInt(input.value);
        if (isNaN(currentValue)) currentValue = 0;
        
        // Explicitly set to 1 if it's 0, otherwise increment
        let newValue;
        if (currentValue === 0) {
          newValue = 1;
        } else {
          newValue = currentValue + 1;
        }
        
        // Set the new value
        input.value = newValue;
        
        // Create a custom event to notify other scripts that we've handled this click
        const customEvent = new CustomEvent('beloQuantityChanged', {
          detail: {
            sectionId: this.sectionId,
            index: index,
            value: newValue,
            input: input
          },
          bubbles: true
        });
        button.dispatchEvent(customEvent);
        
        // Update UI immediately
        updateFlavorInstruction();
        updateButtonState();
        this.updateSelectedFlavors(flavorId, newValue);
        
        // For all flavors, ensure the value is correct after a short delay
        // This handles any external scripts that might change the value
          setTimeout(() => {
            if (parseInt(input.value) !== newValue) {
              input.value = newValue;
              
              // Update UI again after fixing the value
              updateFlavorInstruction();
              updateButtonState();
              this.updateSelectedFlavors(flavorId, newValue);
            }
          }, 50);
      }, true); // Use capture phase to ensure our handler runs first
    });
    
    // Direct input changes
    this.elements.quantityInputs.forEach(input => {
      input.addEventListener('change', () => {
        const flavorId = input.getAttribute('data-flavor');
        let newValue = parseInt(input.value);
        
        // Ensure value is not negative
        if (isNaN(newValue) || newValue < 0) {
          newValue = 0;
          input.value = 0;
        }
        
        // Calculate how many items would be in total with this change
        let potentialTotal = this.state.totalItems;
        if (this.state.selectedFlavors[flavorId]) {
          potentialTotal -= this.state.selectedFlavors[flavorId];
        }
        potentialTotal += newValue;
        
        // If potential total exceeds selected quantity, adjust the value
        if (potentialTotal > this.state.selectedQuantity) {
          newValue = this.state.selectedQuantity - (potentialTotal - newValue);
          input.value = newValue;
        }
        
        this.updateSelectedFlavors(flavorId, newValue);
        updateFlavorInstruction();
        updateButtonState();
      });
    });
  }

  /**
   * Update the selected flavors state
   */
  updateSelectedFlavors(flavorId, quantity) {
    // Update total items count
    if (this.state.selectedFlavors[flavorId]) {
      this.state.totalItems -= this.state.selectedFlavors[flavorId];
    }
    
    if (quantity > 0) {
      this.state.selectedFlavors[flavorId] = quantity;
    } else {
      delete this.state.selectedFlavors[flavorId];
    }
    
    this.state.totalItems = Object.values(this.state.selectedFlavors).reduce((sum, val) => sum + val, 0);
    
    this.updateOrderSummary();
  }

  /**
   * Update the order summary
   */
  updateOrderSummary() {
    if (!this.elements.selectedItems) return;
    
    // Clear selected items
    this.elements.selectedItems.innerHTML = '';
    
    // Add selected flavors to the summary
    for (const [flavorId, quantity] of Object.entries(this.state.selectedFlavors)) {
      if (quantity > 0) {
        const flavor = this.productConfig.flavors.find(f => f.id === flavorId);
        if (flavor) {
          const itemElement = document.createElement('div');
          itemElement.className = 'selected-item';
          itemElement.innerHTML = `
            <span class="item-quantity">${quantity}x</span>
            <span class="item-name">${flavor.name}</span>
          `;
          this.elements.selectedItems.appendChild(itemElement);
        }
      }
    }
    
    // Calculate subtotal
    const subtotal = this.state.totalItems * this.productConfig.basePrice;
    if (this.elements.subtotalValue) {
      this.elements.subtotalValue.textContent = `A$${subtotal.toFixed(2)}`;
    }
    
    // Calculate subscription discount
    let subscriptionDiscount = 0;
    if (this.state.purchaseType === 'subscribe') {
      subscriptionDiscount = subtotal * (this.productConfig.subscriptionDiscounts[this.state.selectedFrequency]);
      if (this.elements.subscriptionDiscountValue) {
        this.elements.subscriptionDiscountValue.textContent = `-A$${subscriptionDiscount.toFixed(2)}`;
      }
      if (this.elements.subscriptionDiscount) {
        this.elements.subscriptionDiscount.style.display = 'flex';
      }
    } else if (this.elements.subscriptionDiscount) {
      this.elements.subscriptionDiscount.style.display = 'none';
    }
    
    // Calculate quantity discount based on actual total items
    // Determine which quantity discount tier to use based on total items
    let effectiveQuantity = Math.min(4, Math.max(1, this.state.totalItems)); // Clamp between 1 and 4
    const quantityDiscount = this.state.totalItems * this.productConfig.quantityDiscounts[effectiveQuantity];
    if (this.elements.quantityDiscountValue) {
      this.elements.quantityDiscountValue.textContent = `-A$${quantityDiscount.toFixed(2)}`;
    }
    
    // Make sure the quantity discount row is visible if there's a discount
    if (quantityDiscount > 0 && this.elements.quantityDiscountValue) {
      const quantityDiscountRow = this.elements.quantityDiscountValue.closest('.quantity-discount');
      if (quantityDiscountRow) {
        quantityDiscountRow.style.display = 'flex';
      }
    }
    
    // Calculate total
    const total = subtotal - subscriptionDiscount - quantityDiscount;
    if (this.elements.totalValue) {
      this.elements.totalValue.textContent = `A$${total.toFixed(2)}`;
    }
    
    // Enable/disable add to cart button
    if (this.elements.addToCartButton) {
      this.elements.addToCartButton.disabled = this.state.totalItems === 0;
    }
  }

  /**
   * Add to cart functionality
   */
  setupAddToCartButton() {
    if (!this.elements.addToCartButton) return;
    
    this.elements.addToCartButton.addEventListener('click', () => {
      // Prepare the items for cart
      const items = [];
      
      // Debug log to check selected flavors
      console.log('Selected flavors:', this.state.selectedFlavors);
      console.log('Total items:', this.state.totalItems);
      
      // Check if any flavors are selected
      if (Object.keys(this.state.selectedFlavors).length === 0) {
        // If no flavors are selected, check if any quantity inputs have values
        let anyFlavorsSelected = false;
        this.elements.quantityInputs.forEach(input => {
          const value = parseInt(input.value);
          if (!isNaN(value) && value > 0) {
            anyFlavorsSelected = true;
            const flavorId = input.getAttribute('data-flavor');
            this.state.selectedFlavors[flavorId] = value;
          }
        });
        
        if (!anyFlavorsSelected) {
          alert('Please select at least one flavor');
          return;
        }
      }
      
      // Check if we should use the Dynamic Box feature for quantity discounts
      const useDynamicBox = this.state.totalItems > 1; // Use Dynamic Box if more than 1 item
      
      if (useDynamicBox) {
        // Use Skio's Dynamic Box feature for quantity discounts
        this.addItemsAsDynamicBox();
      } else {
        // For single items, use the regular cart flow
        // Now build the items array from the selected flavors
        for (const [flavorId, quantity] of Object.entries(this.state.selectedFlavors)) {
          const flavor = this.productConfig.flavors.find(f => f.id === flavorId);
          
          if (flavor && quantity > 0) {
            const variantIds = {
              'classic-lime': '47381281964325',    // Classic Flavour
              'cool-spirulina': '47381280227621',  // Blue Flavour
              'honey-lemon': '49745724375333',     // Matcha Flavour
              'berries': '47381287272741',         // Mixed Berries Flavour
              'tropical': '47381285896485',         // Tropical Flavour
              'pomegranate': '51313025319205'       // Pomegranate Flavour
            };
            
            // Make sure we have a valid variant ID
            const variantId = variantIds[flavorId];
            if (!variantId) {
              console.error(`No variant ID found for flavor: ${flavorId}`);
              continue; // Skip this flavor
            }
            
            items.push({
              id: variantId,
              quantity: quantity,
              properties: {}
            });
          }
        }
        
        // Check if we have any items to add
        if (items.length === 0) {
          alert('Error: No items selected');
          return;
        }
        
        // Add subscription properties if needed
        if (this.state.purchaseType === 'subscribe') {
          items.forEach(item => {
            item.properties = item.properties || {};
            item.properties['shipping_interval_frequency'] = this.state.selectedFrequency;
            item.properties['shipping_interval_unit_type'] = 'Weeks';
            item.properties['subscription_id'] = 12345; // This would be your actual Skio subscription ID
          });
        }
        
        // Debug log to check items being sent to cart
        console.log('Items to add to cart:', items);
        
        // Send to cart
        this.addItemsToCart(items);
      }
    });
  }

  /**
   * Add items as a Dynamic Box to get quantity discounts
   */
  addItemsAsDynamicBox() {
    // Show loading state
    if (this.elements.addToCartButton) {
      this.elements.addToCartButton.textContent = 'Adding...';
      this.elements.addToCartButton.disabled = true;
    }
    
    // Check if we have access to the DynamicBoxIntegration class
    if (typeof window.DynamicBoxIntegration === 'undefined' || !window.skioIntegration) {
      console.error('DynamicBoxIntegration or skioIntegration not available');
      alert('Error: Dynamic Box integration not available');
      if (this.elements.addToCartButton) {
        this.elements.addToCartButton.textContent = 'Error - Try Again';
        this.elements.addToCartButton.disabled = false;
      }
      return;
    }
    
    // Create a new DynamicBoxIntegration instance
    const dynamicBoxIntegration = new window.DynamicBoxIntegration(window.skioIntegration);
    
    // Map of flavor IDs to variant IDs
    const variantIds = {
      'classic-lime': '47381281964325',    // Classic Flavour
      'cool-spirulina': '47381280227621',  // Blue Flavour
      'honey-lemon': '49745724375333',     // Matcha Flavour
      'berries': '47381287272741',         // Mixed Berries Flavour
      'tropical': '47381285896485',         // Tropical Flavour
      'pomegranate': '51313025319205'       // Pomegranate Flavour
    };
    
    // Create an array of selected items for the Dynamic Box
    const selectedItems = [];
    for (const [flavorId, quantity] of Object.entries(this.state.selectedFlavors)) {
      if (quantity > 0) {
        const variantId = variantIds[flavorId];
        if (!variantId) {
          console.error(`No variant ID found for flavor: ${flavorId}`);
          continue; // Skip this flavor
        }
        
        selectedItems.push({
          variantId: variantId,
          quantity: quantity
        });
      }
    }
    
    // Check if we have any items to add
    if (selectedItems.length === 0) {
      alert('Error: No items selected');
      if (this.elements.addToCartButton) {
        this.elements.addToCartButton.textContent = 'Error - Try Again';
        this.elements.addToCartButton.disabled = false;
      }
      return;
    }
    
    // Fetch the Dynamic Box information from the Skio API
    // For now, we'll use the product ID from the URL: dynamic-box?product=9805359251749
    const productPlatformId = '10263216423205';
    
    // Make a request to the Skio API to get the Dynamic Box information
    fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        productPlatformId: productPlatformId
      })
    })
    .then(response => response.json())
    .then(data => {
      if (!data.ok || !data.DynamicBox) {
        throw new Error('Failed to fetch Dynamic Box information');
      }
      
      // Get the Dynamic Box ID from the response
      const dynamicBoxId = data.DynamicBox.boxId;
      const dynamicBoxIndex = 0; // Use 0 for the first box
      
      // Create an array of items for the cart
      const boxItems = [];
      
      // Add each selected flavor to the box items
      for (const item of selectedItems) {
        boxItems.push({
          id: item.variantId,
          quantity: item.quantity,
          properties: {
            '_dynamicBoxId': dynamicBoxId,
            '_dynamicBoxIndex': dynamicBoxIndex
          }
        });
      }
      
      // Prepare the data for adding the items to the cart
      const cartData = {
        items: boxItems
      };
      
      // Add subscription properties if needed
      if (this.state.purchaseType === 'subscribe') {
        // Get the selling plan ID based on frequency
        const sellingPlanIds = {
          4: 690478285093, // 4-week frequency plan ID
          6: 690478481701  // 6-week frequency plan ID
        };
        
        const sellingPlanId = sellingPlanIds[this.state.selectedFrequency];
        
        if (!sellingPlanId) {
          throw new Error(`No selling plan found for frequency: ${this.state.selectedFrequency}`);
        }
        
        // Add selling plan to each item
        cartData.items = cartData.items.map(item => {
          return {
            ...item,
            selling_plan: sellingPlanId,
            properties: {
              ...item.properties,
              shipping_interval_frequency: this.state.selectedFrequency,
              shipping_interval_unit_type: 'Weeks'
            }
          };
        });
      }
      
      // Debug log to check the Dynamic Box data
      console.log('Adding Dynamic Box to cart:', cartData);
      
      // Send the Dynamic Box to the cart
      this.sendCartRequest(cartData);
    })
    .catch(error => {
      console.error('Error fetching Dynamic Box information:', error);
      alert('Error: ' + error.message);
      if (this.elements.addToCartButton) {
        this.elements.addToCartButton.textContent = 'Error - Try Again';
        this.elements.addToCartButton.disabled = false;
      }
      
      // Fall back to regular cart handling
      this.addItemsToCart(selectedItems.map(item => ({
        id: item.variantId,
        quantity: item.quantity
      })));
    });
  }

  /**
   * Add items to cart via AJAX
   */
  addItemsToCart(items) {
    // Show loading state
    if (this.elements.addToCartButton) {
      this.elements.addToCartButton.textContent = 'Adding...';
      this.elements.addToCartButton.disabled = true;
    }
    
    // Ensure items is an array and not empty
    if (!Array.isArray(items) || items.length === 0) {
      alert('Error: No items selected');
      if (this.elements.addToCartButton) {
        this.elements.addToCartButton.textContent = 'Error - Try Again';
        this.elements.addToCartButton.disabled = false;
      }
      return;
    }
    
    // Prepare data for Shopify AJAX API
    const data = {
      items: items.map(item => {
        // Ensure we're using the correct format for Shopify cart API
        return {
          id: item.id,
          quantity: item.quantity,
          properties: item.properties || {}
        };
      })
    };
    
    // For subscription items, we need to ensure the selling_plan_id is properly set
    if (this.state.purchaseType === 'subscribe') {
      // Get the selling plan ID based on frequency
      // These are the actual Skio selling plan IDs
      const sellingPlanIds = {
        4: 690478285093, // 4-week frequency plan ID
        6: 690478481701  // 6-week frequency plan ID
      };
      
      const sellingPlanId = sellingPlanIds[this.state.selectedFrequency];
      
      if (!sellingPlanId) {
        alert(`Error: No selling plan found for frequency: ${this.state.selectedFrequency}`);
        if (this.elements.addToCartButton) {
          this.elements.addToCartButton.textContent = 'Error - Try Again';
          this.elements.addToCartButton.disabled = false;
        }
        return;
      }
      
      // Add selling_plan to each item
      data.items = data.items.map(item => {
        // Ensure the properties include shipping_interval_frequency
        // This is what Skio looks for to identify subscription items
        const properties = {
          ...item.properties,
          shipping_interval_frequency: this.state.selectedFrequency,
          shipping_interval_unit_type: 'Weeks'
        };
        
        return {
          ...item,
          selling_plan: sellingPlanId,
          properties: properties
        };
      });
    }
    
    // Check if window.skioIntegration exists and if we're in subscription mode
    if (window.skioIntegration && this.state.purchaseType === 'subscribe') {
      // Let Skio integration handle the subscription cart
      try {
        // Pass the items to Skio integration
        window.skioIntegration.processSubscriptionItems(data.items);
      } catch (error) {
        console.error('Error processing subscription with Skio:', error);
        // Fall back to regular cart handling
        this.sendCartRequest(data);
      }
    } else {
      // Regular cart handling
      this.sendCartRequest(data);
    }
  }
  
  /**
   * Send the cart request to Shopify
   */
  sendCartRequest(data) {
    // Validate data before sending
    if (!data || !data.items || !Array.isArray(data.items) || data.items.length === 0) {
      alert('Error: Invalid cart data - no items to add');
      if (this.elements.addToCartButton) {
        this.elements.addToCartButton.textContent = 'Error - Try Again';
        this.elements.addToCartButton.disabled = false;
      }
      return;
    }
    
    // Log the data being sent to the cart for debugging
    console.log('Sending to cart:', data);
    
    // Ensure all items have valid IDs and quantities
    const validItems = data.items.filter(item => item.id && item.quantity > 0);
    if (validItems.length === 0) {
      alert('Error: No valid items to add to cart');
      if (this.elements.addToCartButton) {
        this.elements.addToCartButton.textContent = 'Error - Try Again';
        this.elements.addToCartButton.disabled = false;
      }
      return;
    }
    
    // Update data with only valid items
    const validData = {
      items: validItems
    };
    
    // Send request to add items to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(validData)
    })
    .then(async response => {
      if (!response.ok) {
        // Try to get the error details from the response
        let errorMessage = `HTTP error! Status: ${response.status}`;
        try {
          const errorData = await response.json();
          console.error('Cart API error response:', errorData);
          
          if (errorData && errorData.description) {
            errorMessage += ` - ${errorData.description}`;
          } else if (errorData && errorData.message) {
            errorMessage += ` - ${errorData.message}`;
          }
        } catch (e) {
          console.error('Could not parse error response:', e);
        }
        
        throw new Error(errorMessage);
      }
      return response.json();
    })
    .then(data => {
      console.log('Cart add success:', data);
      // Success - redirect directly to checkout instead of cart
      if (this.elements.addToCartButton) {
    this.elements.addToCartButton.textContent = 'Added to Cart!';
    
    // Reset button text after 2 seconds
    setTimeout(() => {
      if (this.elements.addToCartButton) {
        this.elements.addToCartButton.textContent = 'Add to Cart';
        this.elements.addToCartButton.disabled = false;
      }
    }, 2000);
  }
    })
    .catch(error => {
      console.error('Error adding items to cart:', error);
      
      if (this.elements.addToCartButton) {
        this.elements.addToCartButton.textContent = 'Error - Try Again';
        this.elements.addToCartButton.disabled = false;
      }
      
      // Show error details to help with debugging
      alert('Error adding to cart: ' + error.message);
    });
  }
}

// Initialize all Belo Product Options sections on the page
document.addEventListener('DOMContentLoaded', function() {
  // Function to initialize Belo Product Options
  const initializeBeloProductOptions = function() {
    const sections = document.querySelectorAll('.belo-product-options');
    sections.forEach(container => {
      new BeloProductOptions(container);
    });
  };
  
  // Check if SkioIntegration is already defined
  if (typeof window.SkioIntegration !== 'undefined') {
    // If SkioIntegration is already defined, initialize it if needed
    if (!window.skioIntegration) {
      window.skioIntegration = new SkioIntegration({
        debug: false
      });
    }
    // Then initialize Belo Product Options
    initializeBeloProductOptions();
  } else {
    // If SkioIntegration is not defined yet, wait for it to be loaded
    const checkSkioIntegration = setInterval(function() {
      if (typeof window.SkioIntegration !== 'undefined') {
        clearInterval(checkSkioIntegration);
        // Initialize Skio Integration
        window.skioIntegration = new SkioIntegration({
          debug: false
        });
        // Then initialize Belo Product Options
        initializeBeloProductOptions();
      }
    }, 100); // Check every 100ms
    
    // Set a timeout to prevent infinite waiting
    setTimeout(function() {
      clearInterval(checkSkioIntegration);
      // If SkioIntegration is still not defined after 5 seconds, initialize Belo Product Options anyway
      if (typeof window.SkioIntegration === 'undefined') {
        console.warn('SkioIntegration not loaded after 5 seconds, initializing Belo Product Options without it');
        initializeBeloProductOptions();
      }
    }, 5000);
  }
});

// Handle Shopify section load events for dynamic sections
document.addEventListener('shopify:section:load', function(event) {
  const container = event.target.querySelector('.belo-product-options');
  if (container) {
    new BeloProductOptions(container);
  }
});

// Expose the BeloProductOptions class to the global scope
_b.BeloProductOptions = BeloProductOptions;
window.BeloProductOptions = _b.BeloProductOptions;

})(window, document);
